import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import classnames from 'classnames';
import { treeClass } from './styles';
import { empty } from '../utils/func';
import Node from './Node';

var List =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(List, _PureComponent);

  var _super = _createSuper2(List);

  function List(props) {
    var _this;

    _classCallCheck(this, List);

    _this = _super.call(this, props);
    _this.bindLines = void 0;
    _this.bindList = void 0;
    _this.lines = void 0;
    _this.element = void 0;
    _this.hasExpanded = void 0;
    _this.bindLines = _this.bindElement.bind(_assertThisInitialized(_this), 'lines');
    _this.bindList = _this.bindElement.bind(_assertThisInitialized(_this), 'element');
    _this.renderNode = _this.renderNode.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(List, [{
    key: "getKey",
    value: function getKey(data, index) {
      var _this$props = this.props,
          _this$props$id = _this$props.id,
          id = _this$props$id === void 0 ? '' : _this$props$id,
          keygen = _this$props.keygen;
      if (typeof keygen === 'function') return keygen(data, id);
      if (keygen) return data[keygen];
      return id + (id ? ',' : '') + index;
    }
  }, {
    key: "bindElement",
    value: function bindElement(name, el) {
      this[name] = el;
    }
  }, {
    key: "renderNode",
    value: function renderNode(child, index) {
      var _this$props2 = this.props,
          data = _this$props2.data,
          isRoot = _this$props2.isRoot,
          expanded = _this$props2.expanded,
          keygen = _this$props2.keygen,
          line = _this$props2.line,
          className = _this$props2.className,
          style = _this$props2.style,
          other = _objectWithoutProperties(_this$props2, ["data", "isRoot", "expanded", "keygen", "line", "className", "style"]);

      var id = this.getKey(child, index);
      return (
        /*#__PURE__*/
        React.createElement(Node, Object.assign({}, other, {
          data: child,
          id: id,
          index: index,
          key: id,
          line: line,
          keygen: keygen,
          listComponent: List
        }))
      );
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          data = _this$props3.data,
          expanded = _this$props3.expanded,
          className = _this$props3.className,
          style = _this$props3.style,
          childrenClassName = _this$props3.childrenClassName;
      if (!expanded && !this.hasExpanded) return null;
      this.hasExpanded = true;
      var newStyle = Object.assign({}, style, {
        display: expanded ? 'block' : 'none'
      });
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: classnames(className, childrenClassName),
          ref: this.bindList,
          onDrop: empty,
          onDragOver: empty,
          style: newStyle
        }, data.map(this.renderNode))
      );
    }
  }]);

  return List;
}(PureComponent);

List.defaultProps = {
  id: '',
  line: true,
  className: treeClass('children')
};
export default List;